import { DataServiceOperatorBuilder, DataServiceOperatorTypeEnum, OperatorExtractor, StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../models/fact-mapping.interface';
import { FactExtractor } from '../fact-extractor';

export const PORTFOLIO_FACTS: { [factName: string]: FactMappingInterface } = {
	equityShock: {
		extractor: new FactExtractor([
			new OperatorExtractor(
				new StoreNestedFilterExtractor(
					['risk'],
					'risk.scenarios',
					[
						{ propertyToCompare: 'tag', comparedValue: 'AC_SPX_DN', desiredValueExpression: 'total' }
					]
				),
				100,
				DataServiceOperatorBuilder.build(DataServiceOperatorTypeEnum.MULTIPLY),
				undefined
			)
		], shock => {
			return Math.abs(shock);
		})
	},
	rateShock: {
		extractor: new FactExtractor([
			new OperatorExtractor(
				new StoreNestedFilterExtractor(
					['risk'],
					'risk.scenarios',
					[
						{ propertyToCompare: 'tag', comparedValue: 'AC_10Y_UP', desiredValueExpression: 'total' }
					]
				),
				100,
				DataServiceOperatorBuilder.build(DataServiceOperatorTypeEnum.MULTIPLY),
				undefined
			)
		], shock => {
			return Math.abs(shock);
		})
	},
	twelveMonthTrailingYield: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.characteristics',
				[
					{ propertyToCompare: 'name', comparedValue: 'twelveMonthTrailingYield', desiredValueExpression: 'total' }
				]
			)
		], twelveMonthTrailingYield => twelveMonthTrailingYield)
	},
	expense: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.characteristics',
				[
					{ propertyToCompare: 'name', comparedValue: 'expenseRatio', desiredValueExpression: 'total' }
				]
			)
		], expense => expense)
	}
};
